import TrackingDetails from "./trackingdetails";
import { ButtonPrimary, ButtonPrimarySm } from '../../components/formelements'
import { useHistory } from "react-router";
import { useState } from "react";
import { useEffect } from "react";
import { TrackingSignImageURL, TrackingCnImageURL } from "../../global";

const InputField = ({ label, value, isBadge }) => (
    <div className="col-md-2 mb-3">
      <label className="input-label">{label}</label>
      {isBadge ? (
        <span className="badge-field">{value}</span>
      ) : (
        <input type="text" className="input-field" value={value ? value : "N/A"} readOnly />
      )}
    </div>
  );

function formatAmount (n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};

const CNInfo = ({ data, index }) => {
    const history = useHistory();
    const [showImage, setShowImage] = useState(false)
    const [imageURLOne, setImageURLOne] = useState('')
    const [imageURLTwo, setImageURLTwo] = useState('')

    useEffect(() => {
        const isImageAvailable = async (urlParam,cn, setImageURL) => {
            const url = `${urlParam}/${cn}.jpg`
            // const url = 'http://20.46.47.21/mraabta/CnImage/074811113449983.jpg';
            var image = new Image();
            image.onload = function () {
                if (this.width > 0) {
                    setShowImage(true)
                    setImageURL(url)
                }
            }
            image.onerror = function () {
                setShowImage(false)
                setImageURL('')
            }
            image.src = url;
        }
        if (data.cnStatus === "DELIVERED") {
            isImageAvailable(TrackingSignImageURL, data.cn, setImageURLOne);
        }
        if(data.cnStatus === "UNDELIVERED") {
            isImageAvailable(TrackingCnImageURL, data.cn, setImageURLTwo);
        }
    }, [])

    return (
        <div className="row solid-divider" key={index}>
            {/* <div className="col-12 text-center p-2">
                <h3 style={{ fontSize: 20 }}>Consignment Info</h3>
            </div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consignment Number</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.cn}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consigner</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.shipper}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Booking Date</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.bookingDate}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Pieces</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.pieces}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Weight</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.weight}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Service Type</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.serviceType}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Recieved By</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.receivedBy}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Destination</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.destination}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Origin</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.origin}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Delivery Rider</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.courierName}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Current Status</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.cnStatus}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Ticket No</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.ticketNo}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Ticket Status</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.ticketStatus ? data.ticketStatus === 1 ? 'Open' : 'Close' : ''}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consignee</b></div>
            <div className="col-md-6 col-sm-12 pb-2"><b>{data.consignee}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consignee address</b></div>
            <div className="col-md-6 col-sm-12 pb-2"><b>{data.consigneeAdd}</b></div>
            {showImage && imageURLOne !== '' && <><div className="col-md-2 col-sm-12 pb-2 text-dark"><b>POD</b></div>
                <div className="col-md-2 col-sm-12 pb-2"><a href={imageURLOne} className="btn btn-primary" type="image/JPEG" target="_blank">View Signature</a></div></>}

            {showImage && imageURLTwo !== '' && <><div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Sopport Image</b></div>
                <div className="col-md-2 col-sm-12 pb-2"><a href={imageURLTwo} className="btn btn-primary" type="image/JPEG" target="_blank">View</a></div></>}

            <div className="col pb-2" style={{ textAlign: 'right' }}>
                <ButtonPrimarySm text={(!data.ticketStatus || data.ticketStatus === 0) ? 'Launch Ticket' : 'View Ticket'} onClick={e => {
                    history.push({
                        pathname: '/complaint',
                        state: data
                    });
                }} />
            </div> */}

            {/* <div className="col-12 text-center p-2">
                <h3 style={{ fontSize: 20 }}>Consignment Info</h3>
            </div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consignment Number</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.ConsignmentNumber}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consigner</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.CustomerName}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Booking Date</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.BookingDate}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Pieces</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.Pieces}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Weight</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.Weight}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Service Type</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.ServiceType}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Destination</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.DestinationCity}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Origin</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.OriginCity}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Delivery Rider</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.DeliveryRider}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consignee</b></div>
            <div className="col-md-6 col-sm-12 pb-2"><b>{data.ConsigneeName}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consignee address</b></div>
            <div className="col-md-6 col-sm-12 pb-2"><b>{data.DeliveryAddress}</b></div>
            {showImage && imageURLOne !== '' && <><div className="col-md-2 col-sm-12 pb-2 text-dark"><b>POD</b></div>
                <div className="col-md-2 col-sm-12 pb-2"><a href={imageURLOne} className="btn btn-primary" type="image/JPEG" target="_blank">View Signature</a></div></>}

            {showImage && imageURLTwo !== '' && <><div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Sopport Image</b></div>
                <div className="col-md-2 col-sm-12 pb-2"><a href={imageURLTwo} className="btn btn-primary" type="image/JPEG" target="_blank">View</a></div></>}

            <div className="col pb-2" style={{ textAlign: 'right' }}>
                <ButtonPrimarySm text={(!data.ticketStatus || data.ticketStatus === 0) ? 'Launch Ticket' : 'View Ticket'} onClick={e => {
                    history.push({
                        pathname: '/complaint',
                        state: data
                    });
                }} />
            </div> */}




            {/* <div className="col-12 text-center p-2">
                <h3 style={{ fontSize: 20 }}>Tracking Info</h3>
            </div> */}
            {/* <div className="col-12 table-rseponsive" style={{ height: "36vh", overflowX: "scroll", position: "relative" }}>
                <TrackingDetails data={data.details} />
            </div> */}


<div className="container mt-4">
      <div>
        {/* First Section */}
        <div className="shipment-section">
          <div className="row">
            <InputField label="Consignment Number" value={data?.consignmentNumber} />
            <InputField label="Order ID" value={data?.orderId} />
            <InputField label="Booking Date" value={data?.bookingDate} />
            <InputField label="COD Amount" value={data?.codAmount ? data?.codAmount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')+"/-" : ""} />
            <InputField label="Weight" value={data?.weight ? data?.weight+" KG" : ""} />
            <InputField label="Pieces" value={data?.pieces} />
          </div>
          <div className="row">
            <InputField label="Consignee Name" value={data?.consigneeName} />
            <InputField label="Contact Number" value={data?.contactNo} />
            <InputField label="Destination City" value={data?.destinationCity} />
            <div className="col-md-4 mb-3">
                <label className="input-label">Address</label>
                <textarea  type="text" className="input-field" value={data?.deliveryAddress} readOnly />
            </div>
            <InputField label="Service Type" value={data?.serviceType} />
          </div>
        </div>

        {/* Invoice Section */}
        <div className="shipment-section">
          {/* {
            data.cnTrackingInvDetail.map(e => {
                return (<div className="row">
                    <InputField label="Invoice Number" value={e?.invoiceNumber} />
                    <InputField label="Invoice Date" value={e?.invoiceDate} />
                    <InputField label="Amount Invoiced" value={e?.amountInvoiced ? e.amountInvoiced.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')+"/-": ""} />
                    <InputField label="Invoice Type" value={e?.invoiceType} />
                  </div>)
            })
          } */}
          
          <div className="row">
            <div className="col-md-3 mb-3">
                <label className="input-label">Payment ID</label>
                <input type="text" className="input-field" value={data?.paymentID} readOnly />
            </div><div className="col-md-3 mb-3">
                <label className="input-label">Instrument Number</label>
                <input type="text" className="input-field" value={data?.instrumentNumber} readOnly />
            </div><div className="col-md-3 mb-3">
                <label className="input-label">Payment Date</label>
                <input type="text" className="input-field" value={data?.paymentDate} readOnly />
            </div><div className="col-md-3 mb-3">
                <label className="input-label">Amount Paid</label>
                <input type="text" className="input-field" value={data?.amountPaid ? data?.amountPaid.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')+"/-" : ""} readOnly />
            </div>
            {/* <InputField label="Payment ID" value={data?.paymentID} />
            <InputField label="Instrument Number" value={data?.instrumentNumber} />
            <InputField label="Payment Date" value={data?.paymentDate} />
            <InputField label="Amount Paid" value={data?.amountPaid ? data?.amountPaid.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')+"/-" : ""} /> */}
            {/* <InputField label="Adjusted Payment ID" value={data?.adjustedPaymentID} />
            <InputField label="Payment Adjustment Date" value={data?.adjustedPaymentDate} /> */}
          </div>
        </div>

       

        {/* Action Button */}
        {/* <div className="text-end mt-3">
          <button className="action-btn">ACTION</button>
        </div> */}
      </div>
    </div>

        <div className="parent-div">
                <TrackingDetails data={data.cnTrackingDetail} />
            </div>
        </div>

    )
}

export default CNInfo;